import { useCallback, useSyncExternalStore } from "react";

import {
  subscribeToViewerControlChoices,
  viewerControlChoicesFor,
  type ViewerControlChoices,
} from "../viewerControlChoices";

/** The values the viewer chose in the controls of the board `boardId`, while
 *  it is on screen; undefined for no board or a board not on screen. */
export function useViewerControlChoices(
  boardId: string | undefined,
): ViewerControlChoices | undefined {
  const read = useCallback(
    () =>
      boardId === undefined ? undefined : viewerControlChoicesFor(boardId),
    [boardId],
  );
  return useSyncExternalStore(subscribeToViewerControlChoices, read);
}
